<div class="scroll-to-top-container">
  <button
    type="button"
    mat-mini-fab
    (click)="scrollToTop()"
    class="scroll-to-top-button">
    <mat-icon svgIcon="arrow-up"></mat-icon>
  </button>
</div>
